import React from "react";
import Container from "@/components/marketing/Container";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import HeroBackground from "@/components/marketing/HeroBackground";

/**
 * Reusable service-page hero with the light glass design system.
 * Pass eyebrow, title, subtitle, and optional primary/secondary CTAs.
 */
export default function ServiceHero({
  eyebrow,
  title,
  subtitle,
  primaryCTA,
  secondaryCTA,
}) {
  return (
    <section className="relative pt-20 lg:pt-24 pb-6 sm:pb-7 lg:pb-8 overflow-hidden text-center">
      <HeroBackground />
      <Container className="relative">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-4">
          {eyebrow}
        </div>
        <h1 className="font-heading text-[clamp(36px,5vw,56px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-8 max-w-3xl mx-auto text-heading-gradient">
          {title}
        </h1>
        <p className="text-[16px] lg:text-[17px] leading-[1.55] text-[#6c6c74] max-w-[560px] mx-auto mb-7">
          {subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          {primaryCTA && (
            primaryCTA.onClick ? (
              <button onClick={primaryCTA.onClick}
                className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
                style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
                {primaryCTA.label} <ArrowRight className="inline w-4 h-4 ml-1" />
              </button>
            ) : (
              <Link to={primaryCTA.to}
                className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-brand-gradient text-white whitespace-nowrap transition-opacity hover:opacity-90"
                style={{ boxShadow: "0 8px 20px rgba(124,58,237,0.35)" }}>
                {primaryCTA.label} <ArrowRight className="inline w-4 h-4 ml-1" />
              </Link>
            )
          )}
          {secondaryCTA && (
            <Link to={secondaryCTA.to}
              className="inline-block text-[14px] font-semibold px-6 py-[13px] rounded-[14px] bg-dark-pill text-white whitespace-nowrap transition-colors hover:bg-[#3c3c42]">
              {secondaryCTA.label}
            </Link>
          )}
        </div>
      </Container>
    </section>
  );
}